import { render, staticRenderFns } from "./WindingTemperatureSection.vue?vue&type=template&id=09e1b7ca&scoped=true&"
import script from "./WindingTemperatureSection.vue?vue&type=script&lang=js&"
export * from "./WindingTemperatureSection.vue?vue&type=script&lang=js&"
import style0 from "./WindingTemperatureSection.vue?vue&type=style&index=0&id=09e1b7ca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e1b7ca",
  null
  
)

export default component.exports